import styled from "@emotion/styled";

import {
  fontRoboto,
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
} from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { AppFooter } from "scmp-app/components/app-footer";
import { ArticleImageContainer } from "scmp-app/components/article/article-image/styles";
import { Link } from "scmp-app/components/schema-render/common/link";
import { Table } from "scmp-app/components/schema-render/common/table";
import { Caption, StyledSummary } from "scmp-app/components/schema-render/common/table/styles";
import {
  StyledEm as Em,
  StyledLi as Li,
  StyledOl as Ol,
  StyledStrong as Strong,
  StyledTd as Td,
  StyledUl as Ul,
} from "scmp-app/components/schema-render/content/styles";

export const StyledAdSlot = styled(AdSlot)`
  inline-size: 1px;
  block-size: 1px;
`;

export const Container = styled.div`
  background-color: #f7f7f7;

  ${setFullViewportWidthStyles}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  inline-size: 100%;
  padding-block: 40px;
  padding-inline: 20px;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "clig" off,
    "liga" off;

  ${theme.breakpoints.up("tablet")} {
    min-inline-size: 768px;
    max-inline-size: 776px;
    margin-inline: auto;
    padding-block: 60px;
    padding-inline: 32px;
  }

  ${ArticleImageContainer} {
    display: contents;
  }
`;

export const Headline = styled.h1`
  font-weight: 300;
  font-size: 36px;
  font-family: ${fontRobotoCondensed};

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
  }
`;

export const StyledAppFooter = styled(AppFooter)``;

export const StyledHr = styled.hr`
  inline-size: 100%;
  margin: 0;
  margin-block-start: 28px;
  border-block-start: 1px #777777 solid;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const StyledLink = styled(Link)`
  color: #4585ff;
  line-height: 140%;

  text-decoration-line: underline;
`;

export const Paragraph = styled.p`
  margin-block-start: 16px;

  color: #555555;
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 20px;
  }
`;

export const StyledStrong = styled(Strong)`
  color: #555555;
  font-weight: 700;
  line-height: 140%;
`;

export const StyledBr = styled.div`
  ${StyledLink}+& {
    margin-block-start: 4px;
  }
`;

export const StyledTable = styled(Table)`
  margin-block: 28px 0;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }

  ${Paragraph} {
    margin-block-start: 0;
  }

  ${StyledSummary}:empty, ${Caption}:empty {
    display: none;
  }
`;

export const StyledTd = styled(Td)`
  padding: 0;
`;

export const StyledEm = styled(Em)`
  color: #555555;
  line-height: 140%;
`;

export const StyledLi = styled(Li)`
  & + & {
    margin-block-start: 20px;
  }
`;

export const StyledUl = styled(Ul)`
  margin-block-start: 16px;
  padding-inline-start: 28px;

  color: #555555;
  line-height: 140%;

  & > ${StyledLi} {
    list-style: disc;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 20px;
  }
`;

export const StyledOl = styled(Ol)`
  margin-block-start: 16px;
  padding-inline-start: 28px;

  color: #555555;
  line-height: 140%;

  & > ${StyledLi} {
    list-style: decimal;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 20px;
  }
`;

export const Heading1 = styled.h1`
  margin-block-start: 28px;

  font-weight: 300;
  font-size: 36px;
  font-family: ${fontRobotoCondensed};

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;

    font-size: 48px;
  }
`;

export const Heading2 = styled.h2`
  margin-block-start: 28px;

  font-size: 22px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;

    font-size: 28px;
  }
`;

export const Heading3 = styled.h3`
  margin-block-start: 28px;

  font-size: 18px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;

    font-size: 22px;
  }
`;

export const Heading4 = styled.h4`
  margin-block-start: 28px;

  color: #777777;
  font-size: 18px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;

    font-size: 22px;
  }
`;

export const Heading5 = styled.h5`
  margin-block-start: 28px;

  color: #777777;
  font-size: 18px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;

    font-size: 22px;
  }
`;
